import { UPDATE_INSTITUTION_TABLE } from './types';

export const updateInstitutionTableRequest = ({ data, uuid }: any) =>
  ({
    type: UPDATE_INSTITUTION_TABLE.UPDATE_INSTITUTION_TABLE_REQUEST,
    payload: {
      data,
      uuid,
    },
  } as const);

export const updateInstitutionTableSuccess = (data: any) =>
  ({
    type: UPDATE_INSTITUTION_TABLE.UPDATE_INSTITUTION_TABLE_SUCCESS,
    payload: {
      data,
    },
  } as const);

export const updateInstitutionTableFailed = () =>
  ({
    type: UPDATE_INSTITUTION_TABLE.UPDATE_INSTITUTION_TABLE_FAILED,
  } as const);

export type InstitutionTableActions =
  | ReturnType<typeof updateInstitutionTableRequest>
  | ReturnType<typeof updateInstitutionTableSuccess>
  | ReturnType<typeof updateInstitutionTableFailed>;
